// Diagnostics pop-up modal (IM-2465). Opened from the footer so a user can run
// the battery without leaving the page. Wraps the shared DiagnosticsPanel in the
// codebase's MUI Dialog pattern; the Paper is transparent so the panel's own
// theme-token background shows through (theme-aware, no colour literals here).
import { Dialog, DialogContent } from '@mui/material';
import { FC } from 'react';

import DiagnosticsPanel from './diagnostics-panel';

interface Props {
  open: boolean;
  onClose: () => void;
}

const DiagnosticsDialog: FC<Props> = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    aria-label="Diagnostics"
    PaperProps={{ sx: { backgroundColor: 'transparent', backgroundImage: 'none' } }}
  >
    <DialogContent sx={{ p: 0 }}>
      <DiagnosticsPanel variant="modal" onClose={onClose} />
    </DialogContent>
  </Dialog>
);

export default DiagnosticsDialog;
